// import React from 'react';
// import styles from '../../assets/CommonScss/ImagePriview.module.scss';

// const ImagePriview = ({ isOpen, imageUrl, onClose }) => {
//   if (!isOpen || !imageUrl) return null;

//   return (
//     <div className={styles.overlay} onClick={onClose}>
//       <div className={styles.modal} onClick={(e) => e.stopPropagation()}>
//         <img src={imageUrl} alt="Preview" className={styles.previewImage} />
//         <button className={styles.closeButton} onClick={onClose}>×</button>
//       </div>
//     </div>
//   );
// };

// export default ImagePriview;

// src/Components/Common/ImagePriview.jsx
import React from 'react';
import { createPortal } from 'react-dom';
import styles from '../../assets/CommonScss/ImagePriview.module.scss';

const ImagePriview = ({ isOpen, imageUrl, onClose }) => {
    if (!isOpen || !imageUrl) return null;

    const content = (
        <div className={styles.overlay} onClick={onClose}>
            <div className={styles.modal} onClick={(e) => e.stopPropagation()}>
                <button className={styles.closeButton} onClick={onClose}>×</button>
                <img src={imageUrl} alt="Full Preview" className={styles.previewImage} />
            </div>
        </div>
    );

    return createPortal(content, document.body);
};

export default ImagePriview;
